import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { projectsDirectoryPageResource } from '@jira/router-resources__project-directory-v3/src/projectsDirectoryPageResource.tsx';
import type { PreloadedQuery } from 'react-relay';
import type {
	SidebarConfigData,
	SidebarConfigQuery,
} from '@jira/navigation-apps__shared-types/src/types.tsx';
import type { ProjectDirectoryLayoutQuery } from '@jira/global-pages__directories-projects-directory-v3/src/ui/page-layout/__generated__/ProjectDirectoryLayoutQuery.graphql';
import type { RouteResource } from '@atlassian/react-resource-router';

export const adminProjectDirectoryResources = (): (
	| RouteResource<{
			response: SidebarConfigData;
			scope: SidebarConfigQuery;
	  }>
	| RouteResource<PreloadedQuery<ProjectDirectoryLayoutQuery, Record<string, unknown>>>
)[] => [navigationSidebarGlobalResource, projectsDirectoryPageResource];
